import {
    ChangeDetectionStrategy,
    Component,
    Injector,
    Input,
    OnDestroy,
    OnInit,
    ViewEncapsulation,
} from '@angular/core';
import { IMediaBankFileReference } from '@fi-shared/media-bank';
import { FiImageSize, FileType } from '@fi-shared/types';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { INameIdObj } from '@fi-shared/fi-shared-interfaces';
import { flatten } from '@uirouter/core';
import { cloneDeep, FiDateTimeFormatOptions, fiDebounce } from '@fi-shared/utils';
import { AppTextService } from '@fi-shared/app-text';
import {
    IChecklist2ReportAnswer,
    IChecklistScheduleForReport,
    IChecklistV2ReportParameter,
    IChecklistV2ReportParameterFilter,
} from '@fi-shared/checklist/fi-checklist2-report/shared/fi-checklist2-report';
import { FiChecklist2ReportHelperService } from '@fi-shared/checklist/fi-checklist2-report/services/fi-checklist2-report-helper.service';
import { FiChecklist2ReportDialogsService } from '@fi-shared/checklist/fi-checklist2-report/services/fi-checklist2-report-dialogs.service';
import { FiChecklist2ReportData } from '@fi-shared/checklist/fi-checklist2-report/shared/fi-checklist2-report-data';
import {
    FiChecklist2ReportType,
    WidgetTableFilterType,
} from '@fi-shared/checklist/fi-checklist2-report/enums/fi-checklist2-report-type';
import { FiChecklist2ReportHistoryService } from '@fi-shared/checklist/fi-checklist2-report/services/fi-checklist2-report-history.service';
import { FiChecklist2ReportDataService } from '@fi-shared/checklist/fi-checklist2-report/services/fi-checklist2-report-data.service';
import { ChecklistV2ReportPages } from '@fi-shared/checklist/fi-checklist2-report/enums/fi-checklist2-report-pages.enum';
import { ILightWeightObjectCollection, LocalSearchModel } from '@fi-shared/models';
import { ILocalSearchParameter } from '@fi-shared/models/models';
import { FiChecklist2ReportOpenChecklistsService } from '@fi-shared/checklist/fi-checklist2-report/services/fi-checklist2-report-open-checklists.service';
import { union } from '@fi-shared/utils/fi-union';
import { ChecklistWidgetTableFilterDataService } from '@fi-shared/checklist/fi-checklist2-report/components/shared/widget-table-filter-data.service';
import { FiChecklist2AttachmentsBase } from '@fi-shared/checklist/fi-checklist2-report/components/shared/fi-checklist2-attachments-base';

export interface IChecklist2ReportViewerAnswerAttachment {
    answerDetails: IChecklist2ReportAnswer;
    mediaBankFileReference: IMediaBankFileReference;
    checkpointName: string;
    checkpointId: number;
    businessUnitName: string;
    businessUnitId: number;
}

@Component({
    selector: 'fi-checklist-attachments-list',
    templateUrl: './fi-checklist-attachments-list.component.html',
    styleUrls: ['./fi-checklist-attachments-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-checklist-attachments-list' },
    standalone: false,
})
export class FiChecklistAttachmentsListComponent extends FiChecklist2AttachmentsBase implements OnInit {
    @Input({ required: true }) initialFilter: IChecklistV2ReportParameterFilter;
    @Input({ required: true }) reportPage: ChecklistV2ReportPages;
    //@Input() answersWithAttachments: IChecklist2ReportAnswer[];
    @Input({ required: true }) reportParameter: IChecklistV2ReportParameter;
    @Input({ required: true }) reportData: FiChecklist2ReportData;
    @Input() availableBusinessUnitIdsByData: number[];
    @Input() availableChecklistScheduleIdsByData: number[];

    protected get reportType(): FiChecklist2ReportType {
        return this.reportParameter.ReportType;
    }
    protected get reportParameterId(): number {
        return this.reportParameter.Id;
    }
    protected get auditMode(): boolean {
        return this.reportData.auditMode;
    }
    protected _answersChanged$ = new Subject<void>();
    protected get answersChanged$(): Observable<void> {
        return this._answersChanged$.asObservable();
    }

    private answerAttachmentViewData: IChecklist2ReportViewerAnswerAttachment[] = [];

    protected currentFilter: IChecklistV2ReportParameterFilter;
    private availableUnits: INameIdObj[] = [];
    private availableCheckpoints: INameIdObj[] = [];
    private availableUsers: INameIdObj[] = [];

    protected availableUserIdsByData: number[] = [];
    //localSearchParameter: ILocalSearchParameter = {};
    //lightWeightObjectCollection: ILightWeightObjectCollection = new LocalSearchModel().getLightWeightObjectCollectionBase();

    //filteredAnswerAttachments$ = new BehaviorSubject<IChecklist2ReportViewerAnswerAttachment[]>([]);

    constructor(
        injector: Injector,
        /*
                private fiChecklist2ReportHelperService: FiChecklist2ReportHelperService,
                private fiChecklist2ReportOpenChecklistsService: FiChecklist2ReportOpenChecklistsService,
                private fiChecklist2ReportHistoryService: FiChecklist2ReportHistoryService,
                private widgetTableFilterDataService: WidgetTableFilterDataService,
*/
    ) {
        super(injector);
    }

    ngOnInit() {
        this.currentFilter = cloneDeep(this.initialFilter);
        //this.currentFilter.OnlyWithAttachments = true;
        super.ngOnInit();
        //this.setAvailableSearchOptions();
        //this.updateAnswerAttachmentViewData();
        //this.updateFilteredAnswerAttachments();
        this.fiChecklist2ReportDataService.subscribeOnFilterOrDateRangeChanged(
            this.reportParameter.Id,
            this.ngOnDestroy$,
            () => {
                //this.getChecklistAnswerDetails();
                this._answersChanged$.next();
            },
        );
    }

    /*private updateAnswerAttachmentViewData() {
        this.answerAttachmentViewData = [];
        this.answersWithAttachments.forEach((answer: IChecklist2ReportAnswer) => {
            answer.MediaBankFileReferences.forEach((mediaBankFileReference: IMediaBankFileReference) => {
                this.answerAttachmentViewData.push({
                    answerDetails: answer,
                    mediaBankFileReference,
                    checkpointName: answer.CheckpointName,
                    checkpointId: answer.CheckpointId,
                    businessUnitName: answer.BusinessUnitName,
                    businessUnitId: answer.BusinessUnitId,
                });
            });
        });
    }*/

    /*private setAvailableSearchOptions() {
        this.answersWithAttachments.forEach((answerWithAttachment: IChecklist2ReportAnswer, index: number) => {
            const businessUnitIndex: number = this.availableUnits.findIndex((businessUnit: INameIdObj) => {
                return businessUnit.Id === answerWithAttachment.BusinessUnitId;
            });
            if (businessUnitIndex === -1) {
                this.availableUnits.push({
                    Id: answerWithAttachment.BusinessUnitId,
                    Name: answerWithAttachment.BusinessUnitName
                });
            }
            const checkpointIndex: number = this.availableCheckpoints.findIndex((checkpoint: INameIdObj) => {
                return checkpoint.Id === answerWithAttachment.CheckpointId;
            });
            if (checkpointIndex === -1) {
                this.availableCheckpoints.push({
                    Id: answerWithAttachment.CheckpointId,
                    Name: answerWithAttachment.CheckpointName
                });
            }
            flatten(this.fiChecklist2ReportHelperService.getCreatorDataFromAnswerAttachment(answerWithAttachment))
                .forEach((user: INameIdObj) => {
                    const userIndex: number = this.availableUsers.findIndex((availableUser: INameIdObj) => {
                        return availableUser.Id === user.Id;
                    });
                    if (userIndex === -1)
                        this.availableUsers.push(user)
                });
        });
        this.lightWeightObjectCollection.BusinessUnits = [...this.availableUnits];
        this.lightWeightObjectCollection.Creators = [...this.availableUsers];
        this.lightWeightObjectCollection.Checkpoints = [...this.availableCheckpoints];

        this.availableUserIdsByData = union(this.availableUserIdsByData, this.availableUsers.map(u => u.Id));
    }*/

    getAttachmentsListEmptyLabel(): string {
        if (!this.items.length) return this.appTextService.get('checklist.report_no_attachments');

        return this.appTextService.get('filter.empty_result');
    }

    //#region fetch and search answer attachments
    /*private getChecklistAnswerDetails() {
        const promise = new Promise<IChecklist2ReportAnswer[]>((resolve, reject) => {
            if (this.reportPage === ChecklistV2ReportPages.AttachmentListOpenChecklists) {
                this.fiChecklist2ReportOpenChecklistsService.getChecklistAnswerDetails(this.currentFilter, this.reportData.auditMode).then(answerDetails => {
                    resolve(answerDetails);
                }, reject);
            }
            else if (this.reportPage === ChecklistV2ReportPages.AttachmentListHistory) {
                this.fiChecklist2ReportHistoryService.getChecklistAnswerDetails(this.currentFilter,
                    this.fiChecklist2ReportDataService.getDateRange(this.reportParameter.Id),
                    this.reportData.auditMode).then(answerDetails => {
                    resolve(answerDetails);
                }, reject);
            }
            else {
                throw new Error(`onSelectedFilterItemsChanged: unknown reportPage ${ChecklistV2ReportPages[this.reportPage]}`)
            }
        });
        promise.then(answerDetails => {
            this.answersWithAttachments = answerDetails;
            this.setAvailableSearchOptions();
            this.updateAnswerAttachmentViewData();
            this.updateFilteredAnswerAttachments();
        }, err => {}});
        return promise;
    }*/

    private onSelectedFilterItemsChangedDebounced = fiDebounce(() => {
        //this.getChecklistAnswerDetails();
        this._answersChanged$.next();
    });
    onSelectedFilterItemsChanged() {
        this.onSelectedFilterItemsChangedDebounced();
    }

    onSearchChanged() {
        //this.updateFilteredAnswerAttachments();
    }

    /*private updateFilteredAnswerAttachments() {
        const filteredAnswerAttachments: IChecklist2ReportViewerAnswerAttachment[] = this.isLocalSearchParameterSet()
            ? this.searchAttachments(this.answerAttachmentViewData)
            : this.answerAttachmentViewData;
        this.filteredAnswerAttachments$.next(filteredAnswerAttachments);
    }*/

    /*private searchAttachments(attachments: IChecklist2ReportViewerAnswerAttachment[]): IChecklist2ReportViewerAnswerAttachment[] {
        return attachments.filter((attachment: IChecklist2ReportViewerAnswerAttachment) => {
            const result: boolean[] = [];
            if (this.localSearchParameter.BusinessUnitIds?.length) {
                result.push(this.localSearchParameter.BusinessUnitIds.includes(attachment.businessUnitId))
            }

            // note: can be not full name if click on "See all matching creators"
            if (this.localSearchParameter.CreatedByUserNames?.length) {
                result.push(this.isSearchFitsAttachmentItemName(this.localSearchParameter.CreatedByUserNames,
                    attachment.mediaBankFileReference.CreatedByUserName));
            }

            // not: can be not full name if click on "See all matching creators"
            if (this.localSearchParameter.CheckpointNames?.length) {
                result.push(this.isSearchFitsAttachmentItemName(this.localSearchParameter.CheckpointNames,
                    attachment.checkpointName));
            }

            return result.every((condition: boolean) => condition);
        });
    }*/

    /*private isSearchFitsAttachmentItemName(searchNames: string[], attachmentItemName: string): boolean {
        return searchNames.includes(attachmentItemName) ||
            searchNames.every((searchName: string) => attachmentItemName.includes(searchName));
    }

    private isLocalSearchParameterSet(): boolean {
        return !!Object.values(this.localSearchParameter).filter((value) => Array.isArray(value) && value.length).length;
    }*/

    getWidgetTableFilterType(): WidgetTableFilterType {
        if (this.reportPage === ChecklistV2ReportPages.AttachmentListOpenChecklists)
            return WidgetTableFilterType.ChecklistOpenAttachmentsList;
        if (this.reportPage === ChecklistV2ReportPages.AttachmentListHistory)
            return WidgetTableFilterType.ChecklistHistoryAttachmentsList;
        throw new Error(`getWidgetTableFilterType: unknown reportPage ${this.reportPage}`);
    }

    //#endregion

    protected readonly FiDateTimeFormatOptions = FiDateTimeFormatOptions;
    protected readonly FiImageSize = FiImageSize;
    protected readonly WidgetTableFilterType = WidgetTableFilterType;
}
